import { createRoot } from 'react-dom/client'

import './index.css'

// Initialize MUI X license key early, before any components are rendered
import './config/muiLicense'

import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'

import { App } from './App'
import { SnackbarProvider } from './contexts'
import { store } from './store'
import QueryProvider from './providers/QueryProvider'
import { installGlobalErrorHandlers } from './utils/errorReporter'

// VRG-721 — `window.onerror` + `unhandledrejection` feed the same automatic reporter
// as render crashes and error toasts, under the same caps. Before render, so an error
// thrown while the app is still mounting is caught too.
installGlobalErrorHandlers()

const rootElement = document.getElementById('app') as HTMLElement
const root = createRoot(rootElement)

root.render(
  <Provider store={store}>
    <QueryProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SnackbarProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            {/* <Sprite /> */}
            <App />
          </BrowserRouter>
        </SnackbarProvider>
      </LocalizationProvider>
    </QueryProvider>
    <script src="http://status.vera.inc/embed/script.js"></script>
  </Provider>
)
